import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'

export default createGlobalStyle`
  html, body, #app {
    padding: 0;
    margin: 0;
    height: 100%;
    width: 100%;
    background: ${theme.colors.bgLight};
    color: ${theme.colors.paragraph};
    font-family: ${theme.fonts.textFont};
    font-weight:${theme.fonts.fontWeightNormal};
    font-size: ${theme.fonts.fontSize16};
    line-height: normal;
    overflow: hidden;

    -webkit-font-smoothing: antialiased; // Ensures font smoothing for these elements
    -moz-osx-font-smoothing: grayscale; // Provides smoother font rendering on Firefox

    ${theme.mediaQueries.mobile} {
      font-size: ${theme.fonts.fontSize14};
    }
  }

  *, *::before, *::after {
      -webkit-font-smoothing: antialiased; // Ensures font smoothing for all elements
      -moz-osx-font-smoothing: grayscale; // Provides smoother font rendering on Firefox
      box-sizing: border-box; // Ensures consistent box-sizing
  }

  /* Styles for the selected text */
  *::selection {
      background-color: ${theme.colors.violet};
      color: ${theme.colors.white};
  }

  /* For browser compatibility, especially with older versions of Safari */
  *::-moz-selection {
      background-color: ${theme.colors.violet};
      color: ${theme.colors.white};
  }

   a {
    text-decoration: none;
    color: inherit; // It's also good to reset link colors so they inherit from their parent

   &:hover {
      text-decoration: none;
    }
  }

  h1, h2, h3, h4, h5, h6, p {
      margin: 0;
      padding: 0;
  }

  /* React Toastify custom theme colors */
  .Toastify__toast-theme--colored.Toastify__toast--success {
    background-color: ${theme.colors.green};
  }

  .Toastify__toast-theme--colored.Toastify__toast--error {
    background-color: ${theme.colors.error};
  }
`
